import { c as _c } from "react/compiler-runtime";
import { PortableText } from "@portabletext/react";
import { MonthlyDonationsPerOutputResult, OutputGraphAnnotation, Outputs } from "../Graphs/Results/Outputs/Outputs";
import styles from "./ResultsOutput.module.scss";
import { thousandize } from "../../../../util/formatting";
import { useMemo, useState } from "react";
import { ResultsOutputMaps } from "./Maps/ResultsOutputMaps";
import { OrganizationSparkline, OrganizationSparklineLegend } from "../Graphs/Results/OrganizationSparkline/OrganizationSparkline";
import { LinkComponent, Links, LinksProps } from "../../../main/blocks/Links/Links";
import { GraphContextData } from "../Graphs/Shared/GraphContext/GraphContext";
import { NavLink } from "../Navbar/Navbar";
import { Toggle } from "../Widget/components/shared/Toggle/Toggle";
import { Outputdonationstableheaders } from "../../../../studio/sanity.types";
export type TransformedMonthlyDonationsPerOutput = {
  via: string;
  organization: string;
  period: Date;
  numberOfOutputs: number;
  sum: number;
}[];
export interface ResultsOutputTextConfig {
  organizationsHeading?: string;
  organizationsDescription?: string;
  directDonationsText?: string;
  smartDistributionText?: string;
  sparkline?: {
    smartDistributionText?: string;
    directDonationsText?: string;
  };
  normalizeYAxisText?: string;
  readMoreDefaultText?: string;
  organizationMappings?: Array<{
    abbreviation: string;
    fullName: string;
  }>;
  locale?: string;
}
export const ResultsOutput: React.FC<{
  graphData: MonthlyDonationsPerOutputResult;
  outputCountries: string[];
  description: any[];
  graphAnnotations?: OutputGraphAnnotation[];
  graphContext: GraphContextData;
  organizationLinks?: {
    abbreviation: string;
    link: NavLink;
  }[];
  links?: LinksProps & {
    title?: string;
  };
  startYear: number;
  textConfig?: ResultsOutputTextConfig;
  tableHeaders?: Outputdonationstableheaders;
}> = t0 => {
  const $ = _c(85);
  const {
    graphData,
    outputCountries,
    description,
    graphAnnotations,
    graphContext,
    organizationLinks,
    links,
    startYear,
    textConfig,
    tableHeaders
  } = t0;
  let t1;
  if ($[0] !== graphData.monthly) {
    t1 = graphData.monthly.flatMap(_temp);
    $[0] = graphData.monthly;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const transformedMonthlyDonationsPerOutput = t1;
  let t2;
  if ($[2] !== transformedMonthlyDonationsPerOutput) {
    t2 = transformedMonthlyDonationsPerOutput.reduce(_temp2, {});
    $[2] = transformedMonthlyDonationsPerOutput;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const groupedByPeriod = t2;
  let t3;
  if ($[4] !== groupedByPeriod) {
    t3 = Object.values(groupedByPeriod);
    $[4] = groupedByPeriod;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const maxY = Math.ceil(Math.max(...t3, 0));
  const [normalizeYAxis, setNormalizeYAxis] = useState(false);
  let t4;
  if ($[6] !== graphData.total.numberOfOutputs || $[7] !== textConfig?.locale) {
    t4 = thousandize(Math.round(graphData.total.numberOfOutputs), textConfig?.locale);
    $[6] = graphData.total.numberOfOutputs;
    $[7] = textConfig?.locale;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <h2 className={styles.outputNumber}>{t4}</h2>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== graphData.output) {
    t6 = <span className={styles.outputName}>{graphData.output}</span>;
    $[11] = graphData.output;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t5 || $[14] !== t6) {
    t7 = <div>{t5}{t6}</div>;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== description) {
    t8 = <PortableText value={description} />;
    $[16] = description;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t7 || $[19] !== t8) {
    t9 = <div className={styles.outputsWrapper}>{t7}{t8}</div>;
    $[18] = t7;
    $[19] = t8;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  const t10 = textConfig?.locale;
  let t11;
  if ($[21] !== outputCountries || $[22] !== t10) {
    t11 = <ResultsOutputMaps outputCountries={outputCountries} locale={t10} />;
    $[21] = outputCountries;
    $[22] = t10;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11 || $[25] !== t9) {
    t12 = <div className={styles.header}><div className={styles.inner}>{t9}{t11}</div></div>;
    $[24] = t11;
    $[25] = t9;
    $[26] = t12;
  } else {
    t12 = $[26];
  }
  const t13 = textConfig?.locale;
  let t14;
  if ($[27] !== graphAnnotations || $[28] !== graphContext || $[29] !== graphData.output || $[30] !== startYear || $[31] !== t13 || $[32] !== tableHeaders || $[33] !== transformedMonthlyDonationsPerOutput) {
    t14 = <Outputs transformedMonthlyDonationsPerOutput={transformedMonthlyDonationsPerOutput} output={graphData.output} graphAnnotations={graphAnnotations} graphContext={graphContext} startYear={startYear} locale={t13} tableHeaders={tableHeaders} />;
    $[27] = graphAnnotations;
    $[28] = graphContext;
    $[29] = graphData.output;
    $[30] = startYear;
    $[31] = t13;
    $[32] = tableHeaders;
    $[33] = transformedMonthlyDonationsPerOutput;
    $[34] = t14;
  } else {
    t14 = $[34];
  }
  const t15 = textConfig?.organizationsHeading || "Organisasjoner";
  let t16;
  if ($[35] !== t15) {
    t16 = <h4>{t15}</h4>;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  const t17 = textConfig?.organizationsDescription || "Donasjoner til anbefalte eller tidligere anbefalte organisasjoner som arbeider med {output}.";
  let t18;
  if ($[37] !== graphData.output || $[38] !== t17) {
    t18 = t17.replace("{output}", graphData.output.toLowerCase());
    $[37] = graphData.output;
    $[38] = t17;
    $[39] = t18;
  } else {
    t18 = $[39];
  }
  let t19;
  if ($[40] !== t18) {
    t19 = <p>{t18}</p>;
    $[40] = t18;
    $[41] = t19;
  } else {
    t19 = $[41];
  }
  const t20 = textConfig?.sparkline;
  let t21;
  if ($[42] !== t20) {
    t21 = <OrganizationSparklineLegend textConfig={t20} />;
    $[42] = t20;
    $[43] = t21;
  } else {
    t21 = $[43];
  }
  let t22;
  if ($[44] !== graphData.total.organizations.length || $[45] !== normalizeYAxis || $[46] !== textConfig?.normalizeYAxisText) {
    t22 = graphData.total.organizations.length > 1 && <div className={styles.normalizeYAxis}><div className={styles.toggleWrapper}><Toggle active={normalizeYAxis} onChange={active => setNormalizeYAxis(active)} /></div>{textConfig?.normalizeYAxisText || "Standardiser y-akse"}</div>;
    $[44] = graphData.total.organizations.length;
    $[45] = normalizeYAxis;
    $[46] = textConfig?.normalizeYAxisText;
    $[47] = t22;
  } else {
    t22 = $[47];
  }
  let t23;
  if ($[48] !== t21 || $[49] !== t22) {
    t23 = <div className={styles.headerControls}>{t21}{t22}</div>;
    $[48] = t21;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== graphData.total.organizations || $[52] !== maxY || $[53] !== normalizeYAxis || $[54] !== organizationLinks || $[55] !== startYear || $[56] !== textConfig?.directDonationsText || $[57] !== textConfig?.locale || $[58] !== textConfig?.organizationMappings || $[59] !== textConfig?.smartDistributionText || $[60] !== transformedMonthlyDonationsPerOutput) {
    let t25;
    if ($[62] !== maxY || $[63] !== normalizeYAxis || $[64] !== organizationLinks || $[65] !== startYear || $[66] !== textConfig?.directDonationsText || $[67] !== textConfig?.locale || $[68] !== textConfig?.organizationMappings || $[69] !== textConfig?.smartDistributionText || $[70] !== transformedMonthlyDonationsPerOutput) {
      t25 = (t26, i) => {
        const [t27] = t26;
        const [organization, value_0] = t27;
        const orgLink = organizationLinks ? organizationLinks.find(l => l.abbreviation === organization) : null;
        return <div key={organization} className={styles.organization}><div className={styles.overview}><strong>{orgAbbrivToName(organization, textConfig?.organizationMappings)}</strong><span>{(textConfig?.directDonationsText || "{amount} kr direkte fra donorer").replace("{amount}", thousandize(Math.round(value_0.direct.sum), textConfig?.locale))}</span><span>{(textConfig?.smartDistributionText || "{amount} kr via smart fordeling").replace("{amount}", thousandize(Math.round(value_0.smartDistribution.sum), textConfig?.locale))}</span>{orgLink && <div className={styles.orgLink}><LinkComponent link={orgLink?.link} /></div>}</div><div className={styles.sparkline}><OrganizationSparkline transformedMonthlyDonationsPerOutput={transformedMonthlyDonationsPerOutput.filter(t => t.organization === organization)} maxY={normalizeYAxis ? maxY : undefined} startYear={startYear} locale={textConfig?.locale || "no-NB"} /></div></div>;
      };
      $[62] = maxY;
      $[63] = normalizeYAxis;
      $[64] = organizationLinks;
      $[65] = startYear;
      $[66] = textConfig?.directDonationsText;
      $[67] = textConfig?.locale;
      $[68] = textConfig?.organizationMappings;
      $[69] = textConfig?.smartDistributionText;
      $[70] = transformedMonthlyDonationsPerOutput;
      $[71] = t25;
    } else {
      t25 = $[71];
    }
    t24 = graphData.total.organizations.map(_temp3).map(t25);
    $[51] = graphData.total.organizations;
    $[52] = maxY;
    $[53] = normalizeYAxis;
    $[54] = organizationLinks;
    $[55] = startYear;
    $[56] = textConfig?.directDonationsText;
    $[57] = textConfig?.locale;
    $[58] = textConfig?.organizationMappings;
    $[59] = textConfig?.smartDistributionText;
    $[60] = transformedMonthlyDonationsPerOutput;
    $[61] = t24;
  } else {
    t24 = $[61];
  }
  let t25;
  if ($[72] !== links || $[73] !== textConfig?.readMoreDefaultText) {
    t25 = links && links.links.length > 0 && <div className={styles.linksWrapper}><p className="inngress">{links.title ?? (textConfig?.readMoreDefaultText || "Les mer:")}</p><Links links={links.links} /></div>;
    $[72] = links;
    $[73] = textConfig?.readMoreDefaultText;
    $[74] = t25;
  } else {
    t25 = $[74];
  }
  let t26;
  if ($[75] !== t16 || $[76] !== t19 || $[77] !== t23 || $[78] !== t24 || $[79] !== t25) {
    t26 = <div className={styles.organizations}>{t16}{t19}{t23}{t24}{t25}</div>;
    $[75] = t16;
    $[76] = t19;
    $[77] = t23;
    $[78] = t24;
    $[79] = t25;
    $[80] = t26;
  } else {
    t26 = $[80];
  }
  let t27;
  if ($[81] !== t12 || $[82] !== t14 || $[83] !== t26) {
    t27 = <div className={styles.wrapper}>{t12}{t14}{t26}</div>;
    $[81] = t12;
    $[82] = t14;
    $[83] = t26;
    $[84] = t27;
  } else {
    t27 = $[84];
  }
  return t27;
};
const orgAbbrivToName = (abbriv: string, mappings?: Array<{
  abbreviation: string;
  fullName: string;
}>) => {
  if (mappings) {
    const mapping = mappings.find(m => m.abbreviation === abbriv);
    if (mapping) {
      return mapping.fullName;
    }
  }

  // Fallback to hardcoded mappings for backwards compatibility
  switch (abbriv) {
    case "hki":
      return "Hellen Keller International";
    case "sight":
      return "Sightsavers";
    case "amf":
      return "Against Malaria Foundation";
    case "sci":
      return "SCI Foundation";
    case "mc":
      return "Malaria Consortium";
    case "ni":
      return "New Incentives";
    case "dtw":
      return "Deworm the World";
    case "end":
      return "Evidence Action the END Fund";
    case "gd":
      return "GiveDirectly";
    case "ubi":
      return "GiveDirectly Borgerlønn";
    case "gdzf":
      return "GiveDirectly Zakat fund";
    case "gdcsf":
      return "GiveDirectly Climate Survival Fund";
    default:
      return abbriv;
  }
};
function _temp(el) {
  return el.organizations.flatMap(org => Object.entries(org).flatMap(t0 => {
    const [key, value] = t0;
    return [{
      via: "direct",
      organization: key,
      period: new Date(parseInt(el.period.split("-")[0]), parseInt(el.period.split("-")[1]) - 1, 1),
      numberOfOutputs: value.direct.numberOfOutputs,
      sum: value.direct.sum
    }, {
      via: "smartDistribution",
      organization: key,
      period: new Date(parseInt(el.period.split("-")[0]), parseInt(el.period.split("-")[1]) - 1, 1),
      numberOfOutputs: value.smartDistribution.numberOfOutputs,
      sum: value.smartDistribution.sum
    }];
  }));
}
function _temp2(acc, curr) {
  const year = curr.period.getFullYear().toString();
  const org_0 = curr.organization;
  acc[`${year}-${org_0}`] = (acc[`${year}-${org_0}`] || 0) + curr.sum;
  return acc;
}
function _temp3(o) {
  return Object.entries(o);
}